import axios from 'axios'
import ApiErrors from '../utilities/ApiErrors';

export default {

    async get(opciones = {}) {

        const pagina = opciones.page ?? 0;
        const cantidad = opciones.rows ?? 5000;
        const sort_nombre = opciones.sortField ?? 'id';
        const sort_orden = opciones.sortOrder ?? 1;
        const filtro = opciones.filters?.global?.value ?? '';
        const borrados = opciones.borrados ?? false;
        const estado = opciones.estado ?? 0;
        const cliente_id = opciones.cliente_id ?? 0;
        const proveedor_id = opciones.proveedor_id ?? 0;
        const proveedor_pdv_id = opciones.proveedor_pdv_id ?? 0;
        const full_info = opciones.full_info ?? false;
        const updated_at_desde = opciones.updated_at_desde ?? '';
        const updated_at_hasta = opciones.updated_at_hasta ?? '';
        const usuario = opciones.usuario ?? '';
        const tipo = opciones.tipo ?? '';
        const detalle = opciones.detalle ?? '';
        const importe = opciones.importe ?? 0;
        const comprobante = opciones.comprobante ?? -1;

        try {
            const { data } = await axios({
                url: `/consumos/?pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}&estado=${estado}&cliente_id=${cliente_id}&proveedor_id=${proveedor_id}&proveedor_pdv_id=${proveedor_pdv_id}&updated_at_desde=${updated_at_desde}&updated_at_hasta=${updated_at_hasta}&usuario=${usuario}&tipo=${tipo}&detalle=${detalle}&importe=${importe}&comprobante=${comprobante}&full_info=${full_info}`, method: 'GET'
            })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },
    
    async exportar(opciones = {}) {

        const pagina = opciones.page ?? 0;
        const cantidad = opciones.rows ?? 5000;
        const sort_nombre = opciones.sortField ?? 'id';
        const sort_orden = opciones.sortOrder ?? 1;
        const filtro = opciones.filters?.global?.value ?? '';
        const borrados = opciones.borrados ?? false;
        const estado = opciones.estado ?? 0;
        const cliente_id = opciones.cliente_id ?? 0;
        const proveedor_id = opciones.proveedor_id ?? 0;
        const proveedor_pdv_id = opciones.proveedor_pdv_id ?? 0;
        const full_info = opciones.full_info ?? false;
        const updated_at_desde = opciones.updated_at_desde ?? '';
        const updated_at_hasta = opciones.updated_at_hasta ?? '';
        const usuario = opciones.usuario ?? '';
        const tipo = opciones.tipo ?? '';
        const detalle = opciones.detalle ?? '';
        const importe = opciones.importe ?? 0;
        const comprobante = opciones.comprobante ?? -1;

        try {
            const { data } = await axios({
                url: `/consumos/exportar?pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}&estado=${estado}&cliente_id=${cliente_id}&proveedor_id=${proveedor_id}&proveedor_pdv_id=${proveedor_pdv_id}&updated_at_desde=${updated_at_desde}&updated_at_hasta=${updated_at_hasta}&usuario=${usuario}&tipo=${tipo}&detalle=${detalle}&importe=${importe}&comprobante=${comprobante}&full_info=${full_info}`, method: 'GET'
            })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async add(consumoNuevo) {

        try {
            const { data } = await axios({ url: `/consumos/`, data: consumoNuevo, method: 'POST' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async update(consumoActualizado) {

        try {
            const { data } = await axios({ url: `/consumos/${consumoActualizado.id}`, data: consumoActualizado, method: 'PUT' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async agregarComprobante(consumoId, comprobante) {
        try {
            const { data } = await axios({ url: `/consumos/comprobante/${consumoId}`, data: comprobante, method: 'POST' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }
    },

    async delete(consumoId) {

        try {
            await axios({ url: `/consumos/${consumoId}`, method: 'DELETE' })
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },
}